export const menuName = "操作审计";
export const menuList = [
  {
    key: "1",
    title: "概览",
    path: "/dashboard/devops/audit/overview",
    src: require("@/assets/svg/icon/overview.svg"),
    checkedSrc: require("@/assets/svg/icon/overview-checked.svg")
  },
  {
    key: "2",
    title: "云端审计",
    path: "/dashboard/devops/audit/cloud",
    src: require("@/assets/svg/icon/cloud.svg"),
    checkedSrc: require("@/assets/svg/icon/cloud-checked.svg")
  },
  {
    key: "3",
    title: "本地审计",
    path: "/dashboard/devops/audit/local",
    src: require("@/assets/svg/icon/local.svg"),
    checkedSrc: require("@/assets/svg/icon/local-checked.svg")
  }
];

export const AUDIT_TABLE_COLUMNS = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    width: 84
  },
  {
    title: "事件时间",
    dataIndex: "time",
    key: "time"
  },
  {
    title: "用户名",
    dataIndex: "userName",
    key: "userName"
  },
  {
    title: "审计名称",
    dataIndex: "auditName",
    key: "auditName"
  },
  {
    title: "审计规则",
    dataIndex: "rule",
    key: "rule"
  },

  {
    title: "审计状态",
    dataIndex: "status",
    key: "status",
    ellipsis: true
  }
];
